import { PageHeader, VisuallyHidden } from '@/design-system';

import { HeaderPageWrapper } from './HeaderPage.styled';
import { useHeaderPage } from './use-header-page';

export const HeaderPage = ({
  hideBackButton = false,
  isMobile = false,
}: {
  hideBackButton?: boolean;
  isMobile?: boolean;
}) => {
  const { pageName, showBackButton, isTopLevel, onBack, hiddenOnMobile, titleHiddenOnMobile } =
    useHeaderPage();

  if (!pageName || (isMobile && hiddenOnMobile)) return null;

  if (isTopLevel && (!isMobile || titleHiddenOnMobile)) {
    return <VisuallyHidden as="h1">{pageName}</VisuallyHidden>;
  }

  return (
    <HeaderPageWrapper>
      <PageHeader
        title={pageName}
        viewport={isMobile ? 'mobile' : 'desktop'}
        onBack={showBackButton && !hideBackButton ? onBack : undefined}
      />
    </HeaderPageWrapper>
  );
};
